var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 7.5C7.67702 7.5 8.64598 7.10491 9.36041 6.40165C10.0748 5.69839 10.4762 4.74456 10.4762 3.75C10.4762 2.75544 10.0748 1.80161 9.36041 1.09835C8.64598 0.395088 7.67702 0 6.66667 0C5.65632 0 4.68735 0.395088 3.97293 1.09835C3.2585 1.80161 2.85714 2.75544 2.85714 3.75C2.85714 4.74456 3.2585 5.69839 3.97293 6.40165C4.68735 7.10491 5.65632 7.5 6.66667 7.5ZM5.30655 8.90625C2.375 8.90625 0 11.2441 0 14.1299C0 14.6104 0.395833 15 0.883929 15H12.4494C12.9375 15 13.3333 14.6104 13.3333 14.1299C13.3333 11.2441 10.9583 8.90625 8.02679 8.90625H5.30655Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.83835ff37cd1b9c4df33b92c981cbac1.svg";
export { ForwardRef as ReactComponent };